<template>
  <div class="vx-row mb-2" v-if="showDataField">
    <div class="vx-col w-full">
      <vs-input-number
        class="w-full"
        :min="structure.min"
        :max="structure.max"
        v-validate="structure.validation"
        :label="fieldLabel"
        v-model="localVal"
        name="field"
        @keyup="changeHandler"
        :maxLength="structure.max"
      />
      <span class="text-danger text-sm" v-show="errors.has('field')">{{ errors.first('field') }}</span>
    </div>
  </div>
</template> 
<script>
import { mapGetters } from "vuex";

import { sidebarMixin } from "../sidebarMixin";

import { bus } from "../../../main";
export default {
  mixins: [sidebarMixin],
  props: {
    index: String,
    structure: {
      type: Object,
      default: () => {},
      required: true
    },
    value: Number,
    validation: ""
  },
  data() {
    return {
      localVal: "",
      name: "",
      tempArray: [],
      currentValueOfShowHideField: true //this is to retain the current value of show and hide
    };
  },

  computed: {
    showDataField() {
      return this.showField();
    }, 
  },

  methods: {
    changeHandler() {
      // this.$emit("error", this.errors.errors);
      this.$validator.validateAll().then(result => {
        this.$emit("error", { index: this.index, value: result });
      });
    },
    handlShowOrHide(data) {
      console.log("data is:", data);
    }
  },
  created() {
    //we emit the default value because if user does not touch it won't be captured in the array
    this.$emit("input", { index: this.index, value: this.value });

    this.localVal = this.value;

    //if local value is undefined we apply the default value found in structure
    if (this.value == undefined) {
      this.localVal = this.structure.value; //assigning the default value

      //if value is undefined and it is required we return false otherwise true
      if (this.structure.required == "yes") {
        if (this.localVal == "" || this.localVal == undefined) {
          this.$emit("error", { index: this.index, value: false });
        } else {
          this.$emit("error", { index: this.index, value: true });
        }
      } else {
        this.$emit("error", { index: this.index, value: true });
      }

      this.$emit("input", {
        index: this.index,
        value: this.structure.value
      });

      //event bus for hiding and showing field based on other field
      bus.$emit("showHideField", {
        index: this.index,
        value: this.structure.value
      });
    }

    this.$watch("localVal", value => {
      this.$emit("input", { index: this.index, value: value });

      if (this.localVal == "" || this.localVal == undefined) {
        this.$emit("error", { index: this.index, value: false });
      } else {
        this.$emit("error", { index: this.index, value: true });
      }

      //event bus for hiding and showing field based on other field
      bus.$emit("showHideField", {
        index: this.index,
        value: value
      });
    });
  }
};
</script>